/**
 * @author kuan
 */

export const ANALYSIS = {
  'setting': {category:'bg_setting', action:'click_setting', label:'背景设置'},
  'blur': {category:'bg_setting', action:'click_setting_blur', label:'背景设置_模糊度'},
  'opacity': {category:'bg_setting', action:'click_setting_opacity', label:'背景设置_透明度'},
  'durationSetting': {category:'video_duration_setting', action:'click_setting', label:'视频时长设置'},
  'durationSetting2': {category:'canvas', action:'click_edit_video_time', label:'画布_剪裁背景'},
  'zoomIn1.25': {category:'bg_setting_focus', action:'click_enlarge_focus_by_1.25', label:'背景变焦_拉近1.25倍'},
  'zoomIn1.5': {category:'bg_setting_focus', action:'click_enlarge_focus_by_1.5', label:'背景变焦_拉近1.5倍'},
  'zoomIn1.75': {category:'bg_setting_focus', action:'click_enlarge_focus_by_1.75', label:'背景变焦_拉近1.75倍'},
  'zoomIn2': {category:'bg_setting_focus', action:'click_enlarge_focus_by_2.0', label:'背景变焦_拉近2.0倍'},
  'zoomOut1.25': {category:'bg_setting_focus', action:'click_shorten_focus_by_1.25', label:'背景变焦_拉远1.25倍'},
  'zoomOut1.5': {category:'bg_setting_focus', action:'click_shorten_focus_by_1.5', label:'背景变焦_拉远1.5倍'},
  'zoomOut1.75': {category:'bg_setting_focus', action:'click_shorten_focus_by_1.75', label:'背景变焦_拉远1.75倍'},
  'zoomOut2': {category:'bg_setting_focus', action:'click_shorten_focus_by_2.0', label:'背景变焦_拉远2.0倍'},
  'zoomDuration': {category: 'bg_setting_focus', action: 'click_time_setting', label: '调整变焦时长'}
}

  export default {
    data () {
      return {
        ANALYSIS
      }
    },
    methods: {
      report (key = 'setting') {
        this.ANALYSIS[key] && this.$analysis(this.ANALYSIS[key]);
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/mixins/analysis/sceneBgSetting.js